import { configureStore } from '@reduxjs/toolkit'

import { rootReducers } from './reducers'
import { errorMiddleware } from './errorMiddleware'
import { apiSlice } from '../hooks/api-slice'

export const store = configureStore({
  reducer: rootReducers,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    })
      .concat(apiSlice.middleware)
      .concat(errorMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
})
